import { useDataValue, useDataChange } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let change = useDataChange({
    context: 'form',
    path: 'assignee',
    viewPath: props.viewPath,
  })

  let person = useDataValue({
    context: 'person',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(person.id === 'delete' ? null : person)
    setFlowTo(normalizePath(props.viewPath, '../../../../No'))
  }
}
